import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppNavbar from "../components/common/AppNavbar";

function MichiganSahanaEvent() {
  return (
    <>
      <AppNavbar />
      <div className="container my-5">
        {/* Header */}
        <div className=" mb-4">
          <h2 className="fw-bold">
            Bharat Abroad Celebrates Michigan Sahana’s Vibrant Showcase of
            Hindustani & Carnatic Music
          </h2>
          <p className="text-muted">February 8, 2026 — Ann Arbor, Michigan</p>
        </div>
        {/* Video Section */}
        <div className="mb-5  ">
          <div className="ratio ratio-16x9">
            <iframe
              src="https://www.youtube.com/embed/55ICsiDzqSI"
              title="Michigan Sahana Event"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* About Bharat Abroad */}
        {/* <div className="card mb-4 shadow-sm">
          <div className="card-body">
            <h4 className="fw-bold">About Bharat Abroad</h4>
            <p>
              <strong>www.bharatabroad.com</strong>
            </p>
            <p>
              Bharat Abroad is a community focused initiative that highlights,
              supports, and amplifies Bharat’s cultural presence across the
              global diaspora. Through event participation, storytelling, and
              engagement with nonresident Indians/Bharat and community
              organizations, Bharat Abroad works to connect people with the
              richness of Indian heritage, promote cultural pride, and
              strengthen networks among Bharatiya communities worldwide.
            </p>
          </div>
        </div> */}

        {/* Main Content */}
        <div className="mb-4">
          <p>
            The cultural spirit of Bharat shone brilliantly on February 7th,
            2026, as Bharat Abroad members attended the Michigan Sahana
            classical music event, hosted at the University of Michigan by the
            Indian/Bharat Origin students. The evening was a rich tapestry of
            melody, rhythm, and heritage, an artistic celebration that
            reaffirmed the strength and continuity of Bharat’s classical
            traditions among Indian/Bharat students abroad.
          </p>

          <p>
            Michigan Sahana (also known as Michigan Sahānā) is a student-led
            performing arts group at the University of Michigan, originally
            established as ICMD (Indian Classical Music & Dance) in Winter 2003.
            Today, the organization stands as a cultural cornerstone for young
            artists passionate about classical Indian forms.
          </p>
        </div>

        {/* Section */}
        <div className="mb-4">
          <h3 className="fw-bold">A Night Filled with Heritage and Harmony</h3>
          <p>
            The event brought together a talented ensemble of students who
            performed Hindustani, Carnatic music and classical dances,
            showcasing the depth of Bharat’s musical and dance lineage. The
            atmosphere was electric yet soulful, as ragas, taal, and traditional
            compositions filled the venue with an essence reminiscent of India’s
            grand classical gatherings.
          </p>

          <p>
            Attendees from Bharat Abroad had the opportunity to speak with
            performers and organizers, discovering that similar Indian classical
            arts groups exist across many universities in the United States and
            even internationally, reaffirming that Bharat’s cultural roots
            continue to blossom far from home.
          </p>
        </div>

        {/* Upcoming Event */}
        <div className="mb-4">
          <h3 className="fw-bold">
            Looking Ahead — A Major Event on April 11th
          </h3>
          <p>
            During conversations with Michigan Sahana members, the Bharat Abroad
            team learned that the group is preparing for a major cultural event
            scheduled for April 11th, 2026. This upcoming showcase promises to
            be even larger and more diverse, making it an unmissable event for
            Michigan’s Bharat/Indian-affiliated community.
          </p>

          <p>
            If the February 7th performances were any indication, the April
            event is poised to be a significant cultural moment on campus, one
            that will likely gather cultural arts enthusiasts from across the
            state.
          </p>
        </div>

        {/* About Michigan Sahana */}
        <div className="card mb-4 shadow-sm">
          <div className="card-body">
            <h3 className="fw-bold">About Michigan Sahana</h3>
            <p>
              Michigan Sahana is committed to promoting Bharat’s classical arts
              including:
            </p>
            <ul>
              <li>Hindustani and Carnatic music</li>
              <li>Multiple styles of Indian classical dance</li>
              <li>Concerts and educational events</li>
            </ul>

            <h5 className="fw-bold mt-3">Their Mission</h5>
            <ol>
              <li>Increasing awareness of Bharat’s classical arts</li>
              <li>Cultivating artistic talent among members</li>
              <li>Producing high-quality performances across traditions</li>
            </ol>
          </div>
        </div>

        {/* Cultural Bridge */}
        <div className="mb-5">
          <h3 className="fw-bold">A Cultural Bridge Across Continents</h3>
          <p>
            The presence of groups like Michigan Sahana highlights the continued
            vibrancy of Bharat’s performing arts within global academic spaces.
            Their dedication allows Indian origin students to stay connected
            with their roots while introducing these traditions to diverse
            audiences.
          </p>

          <p className="fw-semibold">
            Mark your calendars for April 11th — Michigan Sahana’s next grand
            event promises to be unforgettable.
          </p>
        </div>
      </div>
    </>
  );
}

export default MichiganSahanaEvent;
